import IconComponent from "icons/IconComponent";

import DollarSignIcon from "./dollar-sign.svg";

export default (DollarSignIcon as any) as IconComponent;
